<template>
  <LoginContent/>
</template>

<script>
import LoginContent from "@/components/Authentication/LoginContent/LoginContent";

export default {
  name: "LoginPage",
  components: {LoginContent}
};
</script>

<style scoped>

</style>